module.exports = __webpack_public_path__ + "img/font-size-decrease-icon.21c9b0e1.svg";